import { useSelector } from 'react-redux'
import { RouteSandboxSession } from '../../routes'

import * as sessionUserSelector from 'selectors/sessionUser'
import { useEffect } from 'react'

export function useDocumentTitle (title) {
  useEffect(() => {
    const prevTitle = document.title
    document.title = title || 'Relay'
    return () => {
      document.title = prevTitle
    }
  }, [title])
}

export function useSignOutExternal () {
  const logoutEndpoint = useSelector(sessionUserSelector.logoutEndpoint)

  const signOutExternal = () => {
    const currentUrl = process.env.AUTH_CONTINUE.replace(/\/+$/, '')
    const continueUrl = currentUrl + '/sessions/'

    let signOutUrl

    if (logoutEndpoint === RouteSandboxSession.pattern) {
      signOutUrl = currentUrl + RouteSandboxSession.pattern
    } else {
      signOutUrl = logoutEndpoint + '&clearPartner=true&continue=' + continueUrl
    }

    window.location.replace(signOutUrl)
  }

  return { signOutExternal }
}
